import error from "../assets/images/error.png";
import downArrow from "../assets/images/down.svg";
import close from "../assets/images/close.svg";
import language from "../assets/images/language.png";
import intake from "../assets/images/intake.png";
import scribe from "../assets/images/scribe.png";
import backButton from "../assets/images/IosUndo.png";
import meragoHealth from "../assets/images/meragohealth.png";
import pdficon from "../assets/images/pdf.png";
import scribe2 from "../assets/images/scribe2.png";

const assets = {
  error,
  downArrow,
  close,
  language,
  intake,
  scribe,
  backButton,
  meragoHealth,
  pdficon,
  scribe2
};
export default assets;
